import { defaultLanguage } from './../constant';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieManagerService, CustomObserverService } from '../../shared/';
import { CookieNames, LanguageSelector } from '../constant';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {

  private param: string;
  public isLogin: boolean = false;
  public language = defaultLanguage;

  constructor(
    private cookieManagerService: CookieManagerService,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private customObserverService : CustomObserverService

  ) {

  }

  ngOnInit() {
    let token = this.cookieManagerService.getCookie(CookieNames.loginKey, false);
    this.isLogin = token ? true : false;
    // this.router.navigate(['home/statistics/overall']);
    this.customObserverService._currentLanguage$.subscribe(value => {
      this.language = value;
    });
    var lll = this.cookieManagerService.getCookie("Lang", false);
    this.language = lll ? lll : defaultLanguage;

  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/statistics.component.ts